// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"44f7a900","732":"16e4d505"}[chunkId] + ".chunk.js";
};